import OwnerEntity from './OwnerEntity';

export default OwnerEntity;
